import React from 'react';

import CroissanceLanding from '../../components/Croissance';

function CroissanceView() {
  return (
    <CroissanceLanding />
  );
}

export default CroissanceView;
